module.exports = __webpack_public_path__ + "img/car_idle.4cbdd287.svg";